import React, { Component } from "react";
import PropTypes from "prop-types";
import { TouchableHighlight, View } from "react-native";
import Text from "./TextFont";
import * as CONSTANTS from "./../../assets/consts";
import Spinner from "./Spinner";
import { IconButton } from "./Buttons";
import * as faCharCodes from "./../../assets/consts/faCharCodes";

import * as DeviceTypes from "./../components/devices/_deviceTypes";
import Theme from "./../argon-ui/Theme";

import { HStack, VStack } from "native-base";
import LogIconButton from "./LogIconButton";
import { getDir } from "../util";
class AccessControl extends Component {
  static propTypes = {
    isKioskMode: PropTypes.bool,
    text: PropTypes.string.isRequired,
    hint: PropTypes.string,
    doorState: PropTypes.string,
    isDeviceConnected: PropTypes.bool,
    isTampered: PropTypes.bool,
    icon: PropTypes.string,
    customIcon: PropTypes.any,
    iconStyle: PropTypes.shape(),
    iconColor: PropTypes.string,
    isAdmin: PropTypes.bool,
    deviceType: PropTypes.string,
    deviceId: PropTypes.number,
    onTextPress: PropTypes.func,
    onDoorPress: PropTypes.func,
    onDevicePress: PropTypes.func,
    onReportPress: PropTypes.func,
    loadingTimeOut: PropTypes.number,
    ignoreEventLoading: PropTypes.number,
    isActive: PropTypes.bool,
    cameraUId: PropTypes.string,
    onCameraPress: PropTypes.func,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.deviceType == DeviceTypes.MOTION_SENSOR &&
      nextProps.value == true &&
      nextProps.onMovementDetection
    ) {
      nextProps.onMovementDetection();
    }

    if (nextProps.value != prevState.currentValue && prevState.isLoading) {
      if (prevState.ignoreEventLoading > 0) {
        return {
          ignoreEventLoading: prevState.ignoreEventLoading - 1,
          currentValue: nextProps.value,
        };
      } else {
        return { isLoading: false, currentValue: nextProps.value };
      }
    }

    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      currentValue: this.props.value,
      ignoreEventLoading: this.props.ignoreEventLoading || 0,
      isLoading: false,
    };
  }

  handleOnDoorPress = () => {
    if (this.props.value != undefined && this.props.loadingTimeOut != 0) {
      this.setState(
        {
          isLoading: true,
          ignoreEventLoading: this.props.ignoreEventLoading || 0,
        },
        () => {
          setTimeout(() => {
            if (this.state.isLoading && !this.state.ignoreEventLoading) {
              // just release loader if not changed yet by device event
              this.setState({ isLoading: false });
            }
          }, Number(this.props.loadingTimeOut) || 5000);
        }
      );
    }

    this.props.onDoorPress && this.props.onDoorPress();
  };
  handleOnDevicePress = () => {
    if (this.props.value != undefined && this.props.loadingTimeOut != 0) {
      this.setState(
        {
          isLoading: true,
          ignoreEventLoading: this.props.ignoreEventLoading || 0,
        },
        () => {
          setTimeout(() => {
            if (this.state.isLoading && !this.state.ignoreEventLoading) {
              // just release loader if not changed yet by device event
              this.setState({ isLoading: false });
            }
          }, Number(this.props.loadingTimeOut) || 5000);
        }
      );
    }

    this.props.onDevicePress && this.props.onDevicePress();
  };
  handleOnCameraPress = () => {
    this.props.onCameraPress && this.props.onCameraPress();
  };
  handleOnSystemLockPress = () => {
    this.props.onSystemLockPress && this.props.onSystemLockPress();
  };
  handleOnTextPress = () => {
    if (this.props.onTextPress) {
      this.props.onTextPress();
    }
  };

  handleOnReportPress = () => {
    this.props.onReportPress && this.props.onReportPress();
  };

  renderMainIcon = () => {
    let _iconStyle = this.props.iconStyle || {};
    if (this.state.isLoading) return <Spinner />;
    let _icon = null;
    _icon = (
      <HStack
        style={{ paddingLeft: 0 }}
        space={1}
        justifyContent="space-between"
        w="full"
      >
        {/* Camera Icon */}
        {this.props.cameraUId && (
          <IconButton
            style={{
              width: this.props.isKioskMode ? "auto" : 30,
              borderRadius: 25,
              paddingTop: 8,
              marginLeft: this.props.isKioskMode ? 10 : 0,
            }}
            onPress={this.handleOnCameraPress}
            icon={{
              code: faCharCodes.faCctv,
              style: {
                fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
                fontSize: this.props.isKioskMode ? 30 : 26,
                color:
                  this.props.isDeviceConnected != true ||
                  this.props.isTampered == true
                    ? Theme.COLORS.ERROR
                    : "#666666",
                ..._iconStyle,
              },
            }}
          />
        )}
        {/* Device Icon */}
        <IconButton
          style={{
            width: this.props.isKioskMode ? "auto" : 30,
            borderRadius: 25,
            paddingTop: 8,
            marginLeft: this.props.isKioskMode ? 10 : 0,
          }}
          onPress={this.handleOnCameraPress}
          icon={{
            code: this.props.icon,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: this.props.isKioskMode ? 30 : 26,
              color:
                this.props.isDeviceConnected != true ||
                this.props.isTampered == true
                  ? Theme.COLORS.ERROR
                  : "#666666",
              ..._iconStyle,
            },
          }}
        />
        {/* System Lock Icon */}
        <IconButton
          style={{
            width: this.props.isKioskMode ? "auto" : 30,
            borderRadius: 25,
            paddingTop: 8,
            marginLeft: this.props.isKioskMode ? 10 : 0,
          }}
          onPress={this.handleOnSystemLockPress}
          icon={{
            code:
              this.props.isSystemLocked == true
                ? faCharCodes.faLock
                : faCharCodes.faLockOpen,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: this.props.isKioskMode ? 30 : 26,
              color:
                this.props.isSystemLocked == true
                  ? Theme.COLORS.ERROR
                  : "#666666",
              ..._iconStyle,
            },
          }}
        />
        {/* Door Icon */}
        <IconButton
          style={{
            width: this.props.isKioskMode ? "auto" : 30,
            borderRadius: 25,
            paddingTop: 8,
            marginLeft: this.props.isKioskMode ? 0 : 20,
          }}
          onPress={this.props.isAdmin && this.handleOnDoorPress}
          icon={{
            code:
              this.props.doorState == "Closed"
                ? faCharCodes.faDoorClosed
                : this.props.doorState == "Opened" ||
                  this.props.doorState == "HeldOpen"
                ? faCharCodes.faDoorOpen
                : this.props.doorState == "ForcedOpen"
                ? faCharCodes.faSirenOn
                : "",
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_LIGHT,
              fontSize: this.props.isKioskMode ? 30 : 26,
              color:
                this.props.doorState == "HeldOpen" ||
                this.props.doorState == "ForcedOpen"
                  ? Theme.COLORS.ERROR
                  : "#666666",
              paddingTop: 3,
              ..._iconStyle,
            },
          }}
        />
      </HStack>
    );

    return (
      <View>
        {_icon}
        {/** batteryLevel */}
        {this.props.batteryLevel != null &&
          this.props.batteryLevel <= CONSTANTS.WARNING_MIN_BATTERY && (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                style={{
                  color: Theme.COLORS.ERROR,
                  fontSize: 10,
                  paddingTop: 3,
                  paddingHorizontal: 5,
                }}
              >
                {this.props.batteryLevel}%
              </Text>
              <IconButton
                style={{
                  width: 20,
                  borderRadius: 10,
                  paddingTop: 4,
                }}
                icon={{
                  code: faCharCodes.faBatteryQuarter,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 15,
                    color: Theme.COLORS.ERROR,
                  },
                }}
              />
            </View>
          )}
      </View>
    );
  };

  render() {
    if (this.props.isKioskMode) {
      return (
        <TouchableHighlight
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          // onPress={this.handleOnTextPress}
          style={[
            {
              maxWidth: 220,
              minWidth: 210,
              // maxWidth: 310,
              // minWidth: 250,
              flex: 1,
              padding: 10,
              borderRadius: 10,
              borderWidth: 3,
              borderColor: Theme.COLORS.AREA_ITEM_BORDER,
              backgroundColor: Theme.COLORS.AREA_ITEM_BACKGROUND,
              // height: 65,
              direction: getDir(),
              marginBottom: 12,

              // shadowColor: Theme.COLORS.BACKGROUND,
              // shadowOffset: {
              //   width: 0,
              //   height: 3,
              // },
              // shadowOpacity: 0.2,
              // shadowRadius: 6.65,
              // elevation: 4,
            },
          ]}
        >
          <VStack space="2.5">
            {/*  Report Icon & Device Name */}
            <HStack space="3.5">
              {this.props.isAdmin === true && (
                <LogIconButton onPress={this.handleOnReportPress} />
              )}
              <View
                style={{
                  alignItems: "flex-start",
                  flex: 1,
                  justifyContent: "center",
                  flexDirection: "row",
                }}
              >
                <Text
                  // onPress={this.handleOnTextPress}
                  ellipsizeMode="middle"
                  numberOfLines={1}
                  style={{
                    fontSize: 14,
                    // paddingTop: 12,
                    //paddingBottom: 8,
                    color: "#666666",
                    paddingVertical: 10,
                    flex: 1,
                    alignItems: "flex-start",
                  }}
                >
                  {this.props.text}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    paddingTop: 20,
                    color: "#aaaaaa",

                    alignItems: "flex-end",
                  }}
                >
                  {this.props.hint}
                </Text>
              </View>
            </HStack>
            {/*  Main Icon */}
            <HStack justifyContent="flex-end" alignItems="flex-end" w="full">
              {(this.props.icon != "" ||
                this.props.customIcon != undefined) && (
                <View
                  style={{
                    width: "100%",
                    // width: this.props.customIcon == undefined ? 140 : 140,
                    height: 60,
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                    justifyContent: "flex-end",
                    position: "relative",
                  }}
                >
                  {this.props.statusColor && (
                    <View
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: this.props.statusColor,
                        position: "absolute",
                        top: 5,
                        right: 3,
                        shadowColor: this.props.statusColor,
                        shadowOffset: {
                          width: 0,
                          height: 5,
                        },
                        shadowOpacity: 0.2,
                        shadowRadius: 5.62,
                        elevation: 7,
                      }}
                    />
                  )}
                  {this.renderMainIcon()}
                </View>
              )}
            </HStack>
          </VStack>
        </TouchableHighlight>
      );
    }
    return (
      <HStack
        space="2.5"
        style={[
          {
            flexDirection: "row",
            justifyContent: "space-around",
            borderBottomColor: "#eee",
            alignItems: "center",
            borderBottomWidth: 1,
            marginStart: 10,
            marginEnd: 10,
            flex: 1,
            // height: 65,
            direction: getDir(),
          },
        ]}
      >
        {this.props.isAdmin === true && (
          <LogIconButton onPress={this.handleOnReportPress} />
        )}
        <TouchableHighlight
          underlayColor={Theme.COLORS.WHITE}
          // onPress={this.handleOnTextPress}
          style={{
            alignItems: "flex-start",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            borderRadius: 10,
          }}
        >
          <>
            <Text
              ellipsizeMode="middle"
              numberOfLines={1}
              style={{
                fontSize: 16,
                // paddingTop: 12,
                //paddingBottom: 8,
                color: "#666666",
                paddingVertical: 10,
                flex: 1,
                alignItems: "flex-start",
              }}
            >
              {this.props.text}
            </Text>
            <Text
              style={{
                fontSize: 16,
                paddingTop: 20,
                color: "#aaaaaa",

                alignItems: "flex-end",
              }}
            >
              {this.props.hint}
            </Text>
            {(this.props.icon != "" || this.props.customIcon != undefined) && (
              <View
                style={{
                  // width: this.props.customIcon == undefined ? 60 : 120,
                  height: 60,
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {this.props.statusColor && (
                  <View
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: this.props.statusColor,
                      position: "absolute",
                      top: 5,
                      right: 3,
                      shadowColor: this.props.statusColor,
                      shadowOffset: {
                        width: 0,
                        height: 5,
                      },
                      shadowOpacity: 0.2,
                      shadowRadius: 5.62,
                      elevation: 7,
                    }}
                  />
                )}
                {this.renderMainIcon()}
              </View>
            )}
          </>
        </TouchableHighlight>
      </HStack>
    );
  }
}

export default AccessControl;
